import React, { useEffect, useState } from 'react';
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import "./ContactUs.css";
import ContactBG from "../../Assets/contact_us_banner.webp";
import ReCAPTCHA from "react-google-recaptcha";
import Swal from "sweetalert2";
import api ,{ PUBLIC_BASE_URL } from "../../api/api";
import NProgress from "nprogress";
import "nprogress/nprogress.css";

import { MdEmail, MdLocalPhone } from 'react-icons/md';
import { FaLinkedinIn, FaXTwitter, FaFacebookF, FaInstagram } from 'react-icons/fa6';
import { Link } from 'react-router-dom';

const ContactUs = () => {


  NProgress.configure({ showSpinner: false, trickleSpeed: 200 });
  const [loading, setLoading] = useState(true);

  const [captchaValue, setCaptchaValue] = useState(null);

  const handleCaptchaChange = (value) => {
    setCaptchaValue(value);
  };

  const [selectedOption, setSelectedOption] = useState("");
  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    description: "",
    products: "",
  });



  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!captchaValue) {
      Swal.fire({
        icon: "warning",
        title: "CAPTCHA not completed!",
        text: "Please complete the CAPTCHA before submitting.",
      });
      return;
    }

    setLoading(true);
    try {
      const res = await api.post("/contact-us", formData);
      // SweetAlert success popup
      Swal.fire({
        title: "Success!",
        text: "Submitted successfully.",
        icon: "success",
        confirmButtonText: "OK",
      });
      setFormData({
        firstname: "",
        lastname: "",
        email: "",
        phone: "",
        description: "",
        products: "",
      });
    } catch (err) {
      // SweetAlert error popup
      Swal.fire({
        title: "Error!",
        text: "Submission failed. Please try again.",
        icon: "error",
        confirmButtonText: "OK",
      });

      console.error(err);
    } finally {
      setLoading(false);
    }
  };


  const [bannerData, setBannerData] = useState(null);

  useEffect(() => {
     NProgress.start();
    api.get('/contactusbanner')
      .then((response) => {
        // console.log("Banner Data:", response.data);
        if (response.data && response.data.length > 0) {
          setBannerData(response.data[0]); // Access the first banner data
        }
      })
      .catch((error) => console.error("Error fetching contact us banner:", error))
      .finally(() => {
        NProgress.done();    // Stop NProgress when API finishes
        setLoading(false);   // Also set your loading state
      });
  }, []);

  if (!bannerData) {
    return <div>Loading...</div>;
  }



  return (
    <div>
      <Header />

      {/* banner section start  */}
      <section
      className="container-fluid common_banner"
      style={{
        backgroundImage: `url(${PUBLIC_BASE_URL}${bannerData.image})`, // Dynamic background image
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="common_title wow fadeInUp">
              <h1 style={{ color: 'white' }}>{bannerData.title || 'CONTACT US'}</h1> {/* Dynamic title */}
            </div>
          </div>
        </div>
      </div>
    </section>
      {/* banner section end */}

      {/* request form section start  */}
      <section className="container-fluid request_form_section " style={{ backgroundColor: '#f9f9f9', padding: '40px 0' }}>
  <div className="container mb-5">
    <div className="row">
      <div className="col-lg-6 col-md-6 col-sm-12 mt-5" style={{ paddingRight: '30px' }}>
        <div className="common_title fadeInUp" style={{ marginBottom: '20px' }}>
          <h2 style={{ color: '#317ac7', fontSize: '2.5rem', fontWeight: '700', fontFamily: 'Inter, sans-serif', marginBottom: '10px' }}>Get In Touch</h2>
          <p style={{ color: '#444', lineHeight: '1.6', marginTop: "30px", fontSize: '17px', fontWeight: '400', textAlign: 'justify' }}>
            We're eager to hear from you. Please use the contact details below or fill out the form to get in touch with our team.
          </p>
        </div>
        <div style={{ marginTop: '30px', color: '#555' }}>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' , marginTop: "30px"}}>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-geo-alt-fill" viewBox="0 0 16 16" style={{ marginRight: '10px' }}>
              <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z" />
            </svg>
            <span style={{ color: '#444', fontSize: '17px', fontWeight: '400', lineHeight: '1.8' }}>13 S T Workshop Road Govind Shopping Centre Mehsana
              <br />Mehsana - 384002, Gujarat, India</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' , marginTop: "30px"}}>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-telephone-fill" viewBox="0 0 16 16" style={{ marginRight: '10px' }}>
              <path fillRule="evenodd" d="M1.885.511a1 1 0 0 1 .828.98l-1 2.6A1 1 0 0 1 1 4h5a1 1 0 0 1 0 2H1v1a1 1 0 0 1 .171.33l.879 2.2a1 1 0 0 1-.99.936c-.528-.08-1.237-.538-1.237-1.714 0-1.282.589-2.288 1.342-2.823.14-.098.173-.208.135-.32a.849.849 0 0 0-.203-.265zM12 1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h1zm-2 3a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-3zm6 3a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v3z" />
            </svg>
            <span style={{ color: '#444', fontSize: '17px', fontWeight: '400', lineHeight: '1.8' }}>+91-9925042310</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' , marginTop: "30px"}}>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-envelope-fill" viewBox="0 0 16 16" style={{ marginRight: '10px' }}>
              <path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414l-7.95-4.859zM0 4.697v7.104l5.803-3.558L8 9.864l2.197-1.32 5.803 3.558V4.697a2 2 0 0 0-2-2H2a2 2 0 0 0-1.95 1.697z" />
            </svg>
            <span style={{ color: '#444', fontSize: '17px', fontWeight: '400', lineHeight: '1.8' }}>
              khodiyarindustries1@gmail.com
              khodiyarindustries2015@gmail.com</span>
          </div>

          <div style={{ display: 'flex', gap: '20px', marginTop: '30px' }}>
            <Link to="mailto:your_email@example.com" target="_blank" rel="noopener noreferrer" title="Email" style={{ color: '#444' }}>
              <MdEmail size={30} />
            </Link>
            <Link to="tel:+919925042310" target="_blank" rel="noopener noreferrer" title="Contact" style={{ color: '#444' }}>
              <MdLocalPhone size={30} />
            </Link>
            <Link to="https://www.linkedin.com/company/your-linkedin-page" target="_blank" rel="noopener noreferrer" title="LinkedIn" style={{ color: '#0077B5' }}>
              <FaLinkedinIn size={30} />
            </Link>
            <Link to="https://twitter.com/your_twitter" target="_blank" rel="noopener noreferrer" title="X (formerly Twitter)" style={{ color: '#000000' }}>
              <FaXTwitter size={30} />
            </Link>
            <Link to="https://www.facebook.com/your_facebook_page" target="_blank" rel="noopener noreferrer" title="Facebook" style={{ color: '#1877F2' }}>
              <FaFacebookF size={30} />
            </Link>
            <Link to="https://www.instagram.com/your_instagram" target="_blank" rel="noopener noreferrer" title="Instagram" style={{ color: '#E4405F' }}>
              <FaInstagram size={30} />
            </Link>
          </div>
        </div>
      </div>
      <div className="col-lg-6 col-md-6 col-sm-12">
        <div style={{ backgroundColor: '#fff', padding: '30px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)' }}>
          <form action="action_form fadeInUp" onSubmit={handleSubmit}>
            <div className="row mt-5">
              <div className="col-lg-6 col-md-6 col-sm-12" style={{ marginBottom: '20px' }}>
                <div className="form_text">
                  <input
                    className="form-control"
                    type="text"
                    placeholder="First Name"
                    required=""
                    name="firstname"
                    value={formData.firstname}
                    onChange={handleChange}
                    style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '17px', fontWeight: '400', color: '#444' }}
                  />
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12" style={{ marginBottom: '20px' }}>
                <div className="form_text">
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Last Name"
                    required=""
                    name="lastname"
                    value={formData.lastname}
                    onChange={handleChange}
                    style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '17px', fontWeight: '400', color: '#444' }}
                  />
                </div>
              </div>

              <div className="col-lg-12 col-md-12 col-sm-12" style={{ marginBottom: '20px' }}>
                <div className="form_text">
                  <input
                    className="form-control"
                    type="email"
                    placeholder="Email"
                    required=""
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '17px', fontWeight: '400', color: '#444' }}
                  />
                </div>
              </div>
              <div className="col-lg-12 col-md-12 col-sm-12" style={{ marginBottom: '20px' }}>
                <div className="form_text">
                  <input
                    className="form-control"
                    type="tel"
                    placeholder="Phone"
                    required=""
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '17px', fontWeight: '400', color: '#444' }}
                  />
                </div>
              </div>
              <div className="col-lg-12 col-md-12 col-sm-12" style={{ marginBottom: '20px' }}>
                <div className="form-floating form_text">
                  <textarea
                    className="form-control"
                    type="text"
                    placeholder="Type here..."
                    style={{ height: "136px", width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '17px', fontWeight: '400', color: '#444', fontFamily: 'Nunito, sans-serif' }}
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                  ></textarea>
                </div>
              </div>
              <div className="col-lg-12 col-sm-12 col-md-12" style={{ marginBottom: '20px' }}>
                <select
                  className="form-select"
                  name="products"
                  value={formData.products}
                  onChange={handleChange}
                  style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '17px', fontWeight: '400', color: '#444', fontFamily: 'Nunito, sans-serif' }}
                >
                  <option value={selectedOption} style={{ color: '#444', fontSize: '17px', fontWeight: '400', fontFamily: 'Nunito, sans-serif' }}>products</option>
                  <option value="Clear Float Glass" style={{ color: '#444', fontSize: '17px', fontWeight: '400', fontFamily: 'Nunito, sans-serif' }}>Window Glass</option>
                  <option value="Clear Float Glass" style={{ color: '#444', fontSize: '17px', fontWeight: '400', fontFamily: 'Nunito, sans-serif' }}>Car Glass</option>
                  <option value="Clear Float Glass" style={{ color: '#444', fontSize: '17px', fontWeight: '400', fontFamily: 'Nunito, sans-serif' }}>E Rickshaw Glass</option>
                  {/* <option value="Clear Float Glass" style={{ color: '#444', fontSize: '17px', fontWeight: '400', fontFamily: 'Nunito, sans-serif' }}>Automotive Glass</option> */}
                  <option value="Clear Float Glass" style={{ color: '#444', fontSize: '17px', fontWeight: '400', fontFamily: 'Nunito, sans-serif' }}>Commercial Vehicle Glass</option>
                  <option value="Clear Float Glass" style={{ color: '#444', fontSize: '17px', fontWeight: '400', fontFamily: 'Nunito, sans-serif' }}>Automotive Toughened Glass</option>
                  <option value="Clear Float Glass" style={{ color: '#444', fontSize: '17px', fontWeight: '400', fontFamily: 'Nunito, sans-serif' }}>Road & Construction Equipment Glass</option>
                  <option value="Clear Float Glass" style={{ color: '#444', fontSize: '17px', fontWeight: '400', fontFamily: 'Nunito, sans-serif' }}>Automotive Laminated Glass</option>
                  <option value="Clear Float Glass" style={{ color: '#444', fontSize: '17px', fontWeight: '400', fontFamily: 'Nunito, sans-serif' }}>Arctitecture Glass</option>
                  <option value="Clear Float Glass" style={{ color: '#444', fontSize: '17px', fontWeight: '400', fontFamily: 'Nunito, sans-serif' }}>Home Appliance & General Street glasses</option>
                  <option value="Clear Float Glass" style={{ color: '#444', fontSize: '17px', fontWeight: '400', fontFamily: 'Nunito, sans-serif' }}>Railway Window Glass</option>
                  <option value="Tinted Float Glass" style={{ color: '#444', fontSize: '17px', fontWeight: '400', fontFamily: 'Nunito, sans-serif' }}>DGU Glass</option>
                </select>
              </div>
              <div className="col-lg-12 col-sm-12 col-md-12" style={{ marginBottom: '20px' }}>
                <div className="captcha-box">
                  <div className="recaptcha-logo">
                    <ReCAPTCHA
                      sitekey="6LeUIessAAAAAEiEJZ3-i--wUUDacFTxNmXQxdSN"
                      onChange={handleCaptchaChange}
                    />
                  </div>
                </div>
              </div>
              <div className="col-lg-12 col-sm-12 col-md-12">
                <div
                  className="submit_btn"
                  style={{
                    display: "flex",
                    gap: "10px",
                    justifyContent: "flex-end", // Align button to the right
                    alignItems: "center",
                  }}
                >
                  <button
                    type="submit"
                    disabled={loading}
                    style={{ backgroundColor: '#8067f0', color: '#fff', padding: '12px 25px', borderRadius: '6px', border: 'none', cursor: 'pointer', fontSize: '1rem', fontFamily: 'Inter, sans-serif', fontWeight: '700' }}
                  >
                    {loading ? "Submitting..." : "Send message"}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>
      {/* form_section end */}
      {/* <button type="submit" disabled={loading}>{loading ? "Submitting..." : "Submit"}</button> */}
      {/* map section start */}
     {/* map section start */}
<section className="container-fluid map_section mb-5">
  <div className="row">
    <div className="col-lg-12 col-md-12 col-sm-12">
      <div className="google_map">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m13!1m8!1m3!1d3655.9532645245895!2d72.283495!3d23.606009!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjPCsDM2JzIxLjYiTiA3MsKwMTcnMDAuNiJF!5e0!3m2!1sen!2sus!4v1781506849403!5m2!1sen!2sus"
          style={{ width: "100%", height: "500px", border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Company Location"
        ></iframe>
      </div>
    </div>
  </div>
</section>
{/* map section End */}
      {/* map section End */}

      <Footer />
    </div>
  );
};

export default ContactUs;
